enum ButtonType {
    SQUARE = 'square',
    ROUND = 'round',
}

export default ButtonType;
